class FooterAccordion {
  constructor() {
    this.mediaQuery = window.matchMedia('(max-width: 749px)');
    this.handleToggle = this.onToggle.bind(this);
    this.init();
    this.mediaQuery.addEventListener('change', this.init.bind(this));
  }

  init() {
    this.toggles = document.querySelectorAll('.footer-block--menu .footer-block__toggle');
    if (this.mediaQuery.matches) {
      this.enable();
    } else {
      this.disable();
    }
  }

  enable() {
    this.toggles.forEach(toggle => {
      toggle.addEventListener('click', this.handleToggle);
      const content = document.getElementById(toggle.getAttribute('aria-controls'));
      if (content && toggle.getAttribute('aria-expanded') !== 'true') {
        content.hidden = true;
      }
    });
  }

  disable() {
    this.toggles.forEach(toggle => {
      toggle.removeEventListener('click', this.handleToggle);
      const content = document.getElementById(toggle.getAttribute('aria-controls'));
      if (content) content.hidden = false;
    });
  }

  onToggle(event) {
    const toggle = event.currentTarget;
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    if (content) content.hidden = isExpanded;
  }
}

document.addEventListener('DOMContentLoaded', () => new FooterAccordion());
